import { omit } from 'lodash/fp';

export default omit(['simulation', 'contractDocuments']);
